import { FilterOutlined } from '@ant-design/icons';
import { Children, CSSProperties, Fragment, ReactNode } from 'react';
import './PageFilters.css';

type PageFiltersProps = {
	children: ReactNode;
	style?: CSSProperties;
	className?: string;
};

type PageFilterFieldProps = {
	label: string;
	children: ReactNode;
	/** true cuando el filtro no está en su valor neutro (Todos, Desde el inicio, etc.) */
	active?: boolean;
};

export const PageFilterField = ({ label, children, active }: PageFilterFieldProps) => (
	<div className={`page-filters-field${active ? ' page-filters-field--active' : ''}`.trim()}>
		<span className='page-filters-field-label'>{label}</span>
		<div className='page-filters-field-control'>{children}</div>
	</div>
);

export const PageFilters = ({ children, style, className = '' }: PageFiltersProps) => {
	const items = Children.toArray(children).filter(Boolean);
	const hasActiveFilter = items.some(
		(child: any) => child?.props?.active === true
	);

	return (
		<div className={`page-filters${hasActiveFilter ? ' page-filters--active' : ''} ${className}`.trim()} style={style}>
			<div className='page-filters-field page-filters-heading'>
				<span className='page-filters-field-label' aria-hidden='true'>&nbsp;</span>
				<div className='page-filters-field-control'>
					<span className='page-filters-label'>
						<FilterOutlined style={{ fontSize: 15 }} />
						Filtros
					</span>
				</div>
			</div>
			{items.map((child, index) => (
				<Fragment key={index}>
					<div className='page-filters-divider' />
					{child}
				</Fragment>
			))}
		</div>
	);
};
